var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 26.999
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "edit (3)",
  fill: "#26890d"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6144",
  d: "M24.913 16.943a.674.674 0 0 0-.672.676v6a2.024 2.024 0 0 1-2.017 2.027H3.361a2.024 2.024 0 0 1-2.017-2.027V6.008a2.024 2.024 0 0 1 2.017-2.027H9.33a.676.676 0 0 0 0-1.352H3.361A3.374 3.374 0 0 0 0 6.008v17.611a3.374 3.374 0 0 0 3.361 3.379h18.863a3.374 3.374 0 0 0 3.361-3.379v-6a.674.674 0 0 0-.672-.676Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6145",
  d: "M25.317.891a3.041 3.041 0 0 0-4.3 0L8.96 12.947a.676.676 0 0 0-.173.3l-1.585 5.724a.676.676 0 0 0 .832.832l5.724-1.586a.676.676 0 0 0 .3-.173L26.11 5.984a3.044 3.044 0 0 0 0-4.3Zm-14.885 12.5L20.3 3.523l3.186 3.178-9.868 9.868Zm-.636 1.276 2.542 2.543-3.517.974Zm15.359-9.638-.717.717-3.183-3.183.717-.717a1.689 1.689 0 0 1 2.389 0l.793.793a1.692 1.692 0 0 1 .001 2.39Zm0 0"
}))));
export default SvgEdit;